export default __webpack_public_path__ + "static/media/more-about-jumps.c61f0de3.md";